import React from 'react';
import styled from '@emotion/styled';
import { N600, N900 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import { fontCharlieDisplay } from '../styled';
import { useDevopsState } from '../../hook';
import { InputWorkspaceExisting, MarketingConsentCheckBox } from '../component';
import { messages } from '../../messages';

export function SlideWorkspaceExisting() {
  const { locale } = useDevopsState();
  const showMarketinConsent = locale.localeRequiresMarketingCommunicationOptIn;

  return (
    <>
      <Header>
        <SanitizedFormattedHtmlMessage {...messages.slideExistingSiteHeader} />
      </Header>
      <Description>
        <SanitizedFormattedHtmlMessage
          {...messages.slideExistingWorkspaceSubHeader}
        />
      </Description>
      <InputWorkspaceExisting />
      {showMarketinConsent && <MarketingConsentCheckBox controlled={true} />}
    </>
  );
}

const Header = styled.h1`
  font-family: ${fontCharlieDisplay};
  font-style: normal;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  font-size: 32px;
  line-height: 30px;
  color: ${N600};
  letter-spacing: 0.3px;
  max-width: 300px;
  margin: 0 auto 30px auto;
  text-align: center;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 20px;
    text-align: center;
  }
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 300;
  color: ${N900};
  line-height: 28px;
  letter-spacing: -0.7px;
  text-align: center;
  margin-bottom: 42px;

  @media only screen and (max-width: 769px) {
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }
`;
